import { render } from "./CollectionFilter.vue?vue&type=template&id=9cdea528"
import script from "./CollectionFilter.vue?vue&type=script&lang=js"
export * from "./CollectionFilter.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__